import FormattedMessage from 'I18n/components/FormattedMessage';
import { SprocketIcon } from 'foundations-assets';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { H2 } from 'foundations-components/transitional/components/H2';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import ToolRecommendationsForLearningContent from '../ToolRecommendationsForLearningContent';
import { useGetToolRecommendations } from '../../queries/softwareDiscoveryHooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ShortContentFullToolRecommendations = ({
  contentName,
  useCases
}) => {
  const toolRecommendations = useGetToolRecommendations(useCases);
  const {
    shortTitleKey = '',
    descriptionKey = ''
  } = toolRecommendations || {};
  if (!toolRecommendations) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-accent-neutral-default",
    blockSize: "100%",
    inlineSize: "100%",
    paddingBlockStart: "1400",
    paddingInline: "700",
    children: /*#__PURE__*/_jsx(ToolRecommendationsForLearningContent, {
      cardWidth: 250,
      contentName: contentName,
      renderRecommendations: commonContent => {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs(Text, {
            color: "text-alert-on-fill-default",
            marginBlockEnd: "1300",
            marginInline: "1500",
            textAlign: "center",
            children: [/*#__PURE__*/_jsx(MediaObject, {
              align: "center",
              itemRight: /*#__PURE__*/_jsx(SprocketIcon, {
                color: "fill-accent-light-orange-default",
                size: "1100"
              }),
              spacing: "none",
              children: /*#__PURE__*/_jsx(H2, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: shortTitleKey
                })
              })
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: descriptionKey
            })]
          }), /*#__PURE__*/_jsx(View, {
            marginBlock: "500",
            children: commonContent
          })]
        });
      },
      toolsToDisplay: 3,
      useCases: useCases
    })
  });
};
export default ShortContentFullToolRecommendations;